/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { FetchHttpRequest } from './core/FetchHttpRequest';
import { AddressesService } from './services/AddressesService';
import { AwsService } from './services/AwsService';
import { BookingSitesService } from './services/BookingSitesService';
import { CalendarsService } from './services/CalendarsService';
import { CaptchaService } from './services/CaptchaService';
import { ContactService } from './services/ContactService';
import { EventsService } from './services/EventsService';
import { HealthService } from './services/HealthService';
import { IcalService } from './services/IcalService';
import { IcalFixturesService } from './services/IcalFixturesService';
import { LinkService } from './services/LinkService';
import { PaymentsService } from './services/PaymentsService';
import { RatingService } from './services/RatingService';
import { ReportService } from './services/ReportService';
import { SeminarsService } from './services/SeminarsService';
import { SitemapService } from './services/SitemapService';
import { TherapistsService } from './services/TherapistsService';
import { UsersService } from './services/UsersService';
import { WidgetAuthService } from './services/WidgetAuthService';
import { WidgetBookingService } from './services/WidgetBookingService';
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class TebutoApi {
    public readonly addresses: AddressesService;
    public readonly aws: AwsService;
    public readonly bookingSites: BookingSitesService;
    public readonly calendars: CalendarsService;
    public readonly captcha: CaptchaService;
    public readonly contact: ContactService;
    public readonly events: EventsService;
    public readonly health: HealthService;
    public readonly ical: IcalService;
    public readonly icalFixtures: IcalFixturesService;
    public readonly link: LinkService;
    public readonly payments: PaymentsService;
    public readonly rating: RatingService;
    public readonly report: ReportService;
    public readonly seminars: SeminarsService;
    public readonly sitemap: SitemapService;
    public readonly therapists: TherapistsService;
    public readonly users: UsersService;
    public readonly widgetAuth: WidgetAuthService;
    public readonly widgetBooking: WidgetBookingService;
    public readonly request: BaseHttpRequest;
    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = FetchHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? 'https://api.tebuto.local',
            VERSION: config?.VERSION ?? '1.0.0',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });
        this.addresses = new AddressesService(this.request);
        this.aws = new AwsService(this.request);
        this.bookingSites = new BookingSitesService(this.request);
        this.calendars = new CalendarsService(this.request);
        this.captcha = new CaptchaService(this.request);
        this.contact = new ContactService(this.request);
        this.events = new EventsService(this.request);
        this.health = new HealthService(this.request);
        this.ical = new IcalService(this.request);
        this.icalFixtures = new IcalFixturesService(this.request);
        this.link = new LinkService(this.request);
        this.payments = new PaymentsService(this.request);
        this.rating = new RatingService(this.request);
        this.report = new ReportService(this.request);
        this.seminars = new SeminarsService(this.request);
        this.sitemap = new SitemapService(this.request);
        this.therapists = new TherapistsService(this.request);
        this.users = new UsersService(this.request);
        this.widgetAuth = new WidgetAuthService(this.request);
        this.widgetBooking = new WidgetBookingService(this.request);
    }
}

